import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBillingSessions } from "../../api"


export const getBillingData = createAsyncThunk('billing/get-billing-data', async (data) => {
    const { startDate, endDate, clientAppId} = data
    // #region agent log
    fetch('http://127.0.0.1:7766/ingest/f79e61b8-6fbd-4b36-93e1-9879329baecb',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'26fe08'},body:JSON.stringify({sessionId:'26fe08',runId:'sdk-billing-nec-honda',hypothesisId:'H1,H2,H3,H4',location:'solo-dashboard/src/redux/billing/api.js:getBillingData',message:'billing thunk started',data:{startDate,endDate,clientAppId},timestamp:Date.now()})}).catch(()=>{});
    // #endregion
    const res = await getBillingSessions(startDate, endDate, clientAppId)
    // #region agent log
    fetch('http://127.0.0.1:7766/ingest/f79e61b8-6fbd-4b36-93e1-9879329baecb',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'26fe08'},body:JSON.stringify({sessionId:'26fe08',runId:'sdk-billing-nec-honda',hypothesisId:'H1,H2,H3,H4',location:'solo-dashboard/src/redux/billing/api.js:getBillingData',message:'billing thunk received response',data:{hasRes:!!res,hasData:!!(res&&res.data),dataKeys:res&&res.data?Object.keys(res.data):[],monthDates:res&&res.data&&Array.isArray(res.data.month)?res.data.month.map(item=>item.date):null,dayDates:res&&res.data&&Array.isArray(res.data.day)?res.data.day.slice(0,12).map(item=>item.date):null,error:res&&res.error},timestamp:Date.now()})}).catch(()=>{});
    // #endregion
    const parsedData = (res.data)
    return {
        month: [],
        day: [],
        total: {
            avg: 0,
            sessions: 0,
            seconds: 0,
        },
        unitType: undefined,
        ...parsedData,
        error: res && res.error,
        startDate,
        endDate
    }
})

